import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/ztp_logo.png";
import { FaFacebook, FaTelegram, FaXTwitter } from "react-icons/fa6";
import { FaDiscord } from "react-icons/fa";
import { Link as ScrollLink } from 'react-scroll';
import { useNavigate } from "../../hook/useNavigate";
import JoinBetaButton from "../home/JoinBetaButton";

const navLinks = [
    {
        goTo: "playnow",
        linkTitle: "Play Now",
    },
    {
        goTo: "features",
        linkTitle: "Features",
    },
    {
        goTo: "tokenomics",
        linkTitle: "Tokenomics",
    },
    {
        goTo: "roadmap",
        linkTitle: "Roadmap",
    },
    {
        goTo: "faq",
        linkTitle: "FAQ",
    },
];

const socialLinks = [
    {
        goTo: "https://t.me/ztpoker",
        icon: <FaTelegram />,
    },
    {
        goTo: "https://discord.gg/Y3ncVAeuqc",
        icon: <FaDiscord />,
    },
    {
        goTo: "https://x.com/ZeroTrustPoker",
        icon: <FaXTwitter />,
    },
    {
        goTo: "https://www.facebook.com/ZTPoker",
        icon: <FaFacebook />,
    },
];

const Header = () => {
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const { navNewTab } = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <Navbar expand="lg" className={`navbar-main ${isScrolled ? "scrolled" : ""}`}>
                <Container>
                    <div className="d-flex">
                        <Navbar.Toggle aria-controls="offcanvasNavbar-lg" onClick={() => setShowOffcanvas(!showOffcanvas)} />
                        <Navbar.Brand>
                            <ScrollLink
                                activeClass="active"
                                to={"home"}
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                                onClick={() => setShowOffcanvas(false)}
                            >
                                <img style={{ cursor: 'pointer' }} className="logo" src={Logo} alt="Logo" />
                            </ScrollLink>
                        </Navbar.Brand>

                    </div>
                    <div className="header-social d-lg-none">
                        <div style={{ display: 'flex' }}>
                            {socialLinks.map((item, index) => (
                                <div key={index} className="nav-social" style={{ cursor: 'pointer' }} onClick={() => navNewTab(item.goTo)}>
                                    {item.icon}
                                </div>
                            ))}
                        </div>
                    </div>
                    <Navbar.Offcanvas
                        id="offcanvasNavbar-lg"
                        aria-labelledby="offcanvasNavbarLabel-lg"
                        placement="start"
                        show={showOffcanvas}
                        onHide={() => setShowOffcanvas(false)}
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id="offcanvasNavbarLabel-lg">
                                <Link to="/">
                                    <img className="logo" src={Logo} alt="Logo" />
                                </Link>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-start align-items-center flex-grow-1 pe-3">
                                {navLinks.map((item, index) => (
                                    <div key={index} style={{ cursor: 'pointer' }} className={`nav-link`}>
                                        <ScrollLink
                                            activeClass="active"
                                            to={item.goTo}
                                            spy={true}
                                            smooth={true}
                                            offset={-70}
                                            duration={500}
                                            onClick={() => setShowOffcanvas(false)}
                                        >
                                            {item.linkTitle}
                                        </ScrollLink>
                                    </div>
                                ))}
                            </Nav>
                            <Nav className="gap-3 align-items-center">
                                <div style={{ display: 'flex' }}>
                                    {socialLinks.map((item, index) => (
                                        <div key={index} className="nav-social" style={{ cursor: 'pointer' }} onClick={() => navNewTab(item.goTo)}>
                                            {item.icon}
                                        </div>
                                    ))}
                                </div>
                                <JoinBetaButton onClick={() => setShowOffcanvas(false)} />
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </>
    );
};

export default Header;
